import zPage from '../Page/page.vue';
import commentDialog from '@/dialogs/comment.vue';

export default{
    name:'Safeguard',
    data(){
        return{
            value1:0,
            page:{
                targetPage:1,
                pageSize:10,
                totalPage: 0,
                type:2,
            },

            list: [], // 列表

            typeCode: '', // 当前选中的code
            typeTop: [], // 4个类型列表
            typeAll: [], // 所有列表
        }
    },
    components:{
        zPage,
        commentDialog,
    },
    created(){
        this.getTypeTop4();
        this.getTypeAll();
    },
    methods:{
        // 获取4个类型
        getTypeTop4 () {
            this.get(this.api.getTypeTop4).then(res => {
                if (res.result == 200) {
                    this.typeTop = res.data;
                    if (this.typeTop.length) {
                        this.typeCode = this.typeTop[0].code;

                        this.getData();
                    }
                }
            })
        },

        // 获取所有类型
        getTypeAll () {
            this.get(this.api.getTypeAll).then(res => {
                if (res.result == 200) {
                    this.typeAll = res.data;
                }
            })
        },

        getData(){
            var param = {
                pageNumber: this.page.targetPage-1,
                pageSize: this.page.pageSize,
                typeCode: this.typeCode
            }

            this.get(this.api.getPageBzzx, param).then(res => {
                if (res.result == 200) {
                    var data = res.data;
                    this.list = data.list;
                    this.page.totalPage = data.totalElements;
                }
            })
        },

        changePage (val, type) {
            if (type) {
                this.page.targetPage = 1;
                this.page.pageSize = val;
            } else {
                this.page.targetPage = val;
            }
            this.getData();
        },

        setTypeCode (code) {
            this.typeCode = code;
            this.getData();
        },

        handleCommand (command) {
            this.setTypeCode(command);
        },

        // 显示售后评价
        showPostSale (type,id) {
            this.$router.push({path:'/postsale',query:{id:id,type:type}});
        },
    }

}